import React from 'react';
import Isvg from 'react-inlinesvg';
import {trans} from './utils';

let GAMES_TRANS = {
  'en': 'Games',
  'hr': 'Igre',
  'de': 'Spiele',
  'it': 'I giochi',
  'fr': 'Des jeux',
  'cs': 'Hry',
}

export default class Navigation extends React.Component {

  render () {
    let {categories, extra, lang, selected, selectedExtra} = this.props;

    let items = categories.map(cat => {
      let id = cat.poi_category_id,
          cls = id === selected ? 'selected' : '';

      let icon = <span className="isvg" />
      if (cat.svg_icon) icon = <Isvg src={cat.svg_icon} />

      return (
        <li key={id} className={cls} onClick={() => this.onChange(id)}>
          { icon }
          <span className="name">{ trans(lang, cat.name) }</span>
        </li>
      );
    });

    let extraItems = extra.map(ex => {
      let id = ex.extra_content_id,
          cls = id === selectedExtra ? 'selected' : '';

      let icon = <span className="isvg" />
      if (ex.svg_icon) icon = <Isvg src={ex.svg_icon} />

      return (
        <li key={'extra-' + id} className={cls} onClick={() => this.props.onSelectExtra(id)}>
          { icon }
          <span className="name">{ trans(lang, ex.name) }</span>
        </li>
      );
    });

    let games = null;
    if (this.props.games.length > 0) {
      let icon = <span className="isvg" />,
          icon_url = this.props.games_svg_icon,
          cls = this.props.gamesSelected ? 'selected' : '';

      if (icon_url) icon = <Isvg src={icon_url} />
      games = (
        <li key={'games'} className={cls} onClick={() => this.props.onGameSelect(null)}>
          { icon }
          <span className="name">{ trans(lang, GAMES_TRANS) }</span>
        </li>
      );
    }

    let homeSelected = (
      selected == null && selectedExtra == null  && !this.props.gamesSelected
    );

    return (
      <ul className="Navigation">
        <li key='home' className={homeSelected ? 'selected' : ''}
            onClick={() => this.onChange(null)}>
          <Isvg src={require('./img/home_icon.svg')} />
          <span className="name">Home</span>
        </li>

        { items }
        { games }
        { extraItems }
      </ul>
    );
  }

  onChange(id) {
    this.props.onChange(id);
    window.TRACKING_EVENT.event = 'category';
    window.TRACKING_EVENT.source = 'menu';
    window.TRACKING_EVENT.target_id = id;
  }
}

